export default __webpack_public_path__ + "static/harvard_logo-776e7bb1e76321c8579ff3ad388e8451.png";